import { useState } from 'react';
import { useAsyncData } from 'shared/hooks/useAsyncData';
import {
  fetchArenaMuralPosts,
  publishAnnouncement as publishAnnouncementRequest,
  resolveMuralReport,
  updateMuralPostState,
} from 'modules/arena/mural/muralService';
import { ArenaMuralPost } from 'modules/arena/mural/types';

export function useArenaMural() {
  const { data: posts, isLoading, error, setData: setPosts } = useAsyncData<ArenaMuralPost[]>(
    fetchArenaMuralPosts,
    []
  );
  const [filter, setFilter] = useState('all');
  const [announcementText, setAnnouncementText] = useState('');

  const filteredPosts = posts.filter((post) => {
    if (filter === 'removido') return post.state === 'removido';
    if (post.state === 'removido') return false;
    if (filter === 'all') return true;
    if (filter === 'denunciado') return post.reportCount > 0;
    return post.kind === filter;
  });

  async function publishAnnouncement() {
    if (!announcementText.trim()) return;

    const newPost = await publishAnnouncementRequest(announcementText.trim());
    setPosts((prev) => [newPost, ...prev]);
    setAnnouncementText('');
  }

  function removePost(id: string) {
    setPosts((prev) => prev.map((post) => (post.id === id ? { ...post, state: 'removido' } : post)));
    updateMuralPostState(id, 'removido').catch(() => {});
  }

  function restorePost(id: string) {
    setPosts((prev) => prev.map((post) => (post.id === id ? { ...post, state: 'ativo' } : post)));
    updateMuralPostState(id, 'ativo').catch(() => {});
  }

  function resolveReport(id: string) {
    setPosts((prev) => prev.map((post) => (post.id === id ? { ...post, reportCount: 0 } : post)));
    resolveMuralReport(id).catch(() => {});
  }

  return {
    posts,
    isLoading,
    error,
    filteredPosts,
    filter,
    setFilter,
    announcementText,
    setAnnouncementText,
    publishAnnouncement,
    removePost,
    restorePost,
    resolveReport,
  };
}
